import React from "react";
import Loadable from "@loadable/component";
import { graphql, Link, useStaticQuery } from "gatsby";
import img1 from "../../assets/images/industry_info/sidebar/1.png";
import img2 from "../../assets/images/industry_info/sidebar/2.png";

const OwlCarousel = Loadable(() => import("react-owl-carousel3"));

const IndustryItem = ({ industry }) => {
  return (
    <article className="item">
      <Link to={`/industry/${industry.strapiId}`} className="thumb">
        {industry.image && industry.image.childImageSharp && <img className="rounded" src={industry.image.childImageSharp.fixed.src} alt="人力资源软件" />}
      </Link>
      <div className="info">
        <span>{industry.date}</span>
        <h4 className="title usmall">
          <Link to={`/industry/${industry.strapiId}`}>{industry.title}</Link>
        </h4>
      </div>
      <div className="clear"></div>
    </article>
  );
};

/**
 *
 * @param {object} props
 * @param {{name: string, count: number}[]} props.tags
 * @returns
 */
const TagBlock = ({ tags }) => {
  if (!Array.isArray(tags) || tags.length === 0) {
    return null;
  }
  return (
    <div className="widget widget_tag_cloud">
      <h3 className="widget-title">标签</h3>
      <div className="tagcloud">
        <Link to={`/industryInfo/all/page_1`}>全部</Link>
        {tags.map(tag => {
          return (
            <Link to={`/industryInfo/tag_${tag.strapiId}/page_1`} key={tag.name}>
              {tag.name}
              {tag.count > 0 && <span className="tag-link-count">({tag.count || 0})</span>}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

const Sidebar = () => {
  const data = useStaticQuery(
    graphql`
      {
        hots: allStrapiIndustry(limit: 3, sort: { order: DESC, fields: published_at }) {
          nodes {
            title
            slug
            desc
            content
            strapiId
            date
            image {
              childImageSharp {
                fixed {
                  src
                }
              }
            }
          }
        }
        recommends: allStrapiIndustry(limit: 3, filter: { recommended: { eq: true } }, sort: { fields: updated_at, order: DESC }) {
          nodes {
            title
            slug
            desc
            content
            strapiId
            date
            image {
              childImageSharp {
                fixed {
                  src
                }
              }
            }
          }
        }
        tags: allStrapiIndustryTag {
          nodes {
            strapiId
            name
          }
        }
      }
    `
  );

  const options = {
    loop: true,
    nav: false,
    dots: false,
    autoplaySpeed: 2000,
    autoplayHoverPause: true,
    autoplay: true,
    items: 1,
  };

  return (
    <div className="widget-area">
      <TagBlock tags={data.tags.nodes} />
      <div className="widget widget_tracer_posts_thumb">
        <h3 className="widget-title">热门文章</h3>
        {data.hots.nodes.map(industry => (
          <IndustryItem industry={industry} key={industry.slug} />
        ))}
      </div>
      <div className="widget widget_tracer_posts_thumb">
        <h3 className="widget-title">推荐文章</h3>
        {data.recommends.nodes.map(industry => (
          <IndustryItem industry={industry} key={industry.slug} />
        ))}
      </div>
      <div className="widget widget_tracer_posts_thumb">
        <OwlCarousel className="case-study-slides owl-carousel owl-theme" {...options}>
          <Link to="/performance">
            <img src={img1} className="ma img-fluid shadow rounded mt-4 mb-4" alt="绩效配置根据企业量身定制" height="80%" />
          </Link>
          <Link to="/reservation">
            <img src={img2} className="ma img-fluid shadow rounded mt-4 mb-4" alt="预约系统演示" height="80%" />
          </Link>
        </OwlCarousel>
      </div>
    </div>
  );
};

export default Sidebar;
